import './Terms.scss';

import { PLANO_BASICO, PLANO_ESSENCIAL, PLANO_PREMIUM } from './constants';
import React, { useEffect } from 'react';

import Accordion from '../../components/Accordion';
import { scrollWindowToTop } from '../../utils/scroll';
import { useWebview } from '../../hooks/useWebview';

export function Terms(): JSX.Element {
  const { shouldHideHeader } = useWebview();

  useEffect(() => {
    scrollWindowToTop();
  }, []);

  return (
    <div className={`my-listings main-content ${shouldHideHeader() ? 'hide-header' : ''}`}>
      <div className="my-listings__main">
        <span className="my-listings__main-title">
          Termo de Adesão ao pacote de anúncios iCarros
        </span>
      </div>
      <div className="insurances__info-container">
        <ol className="terms__decimal-list">
          <li className="terms__decimal-item">
            <strong>Composição e Características do Pacote Contratado</strong>
            <ol className="terms__decimal-list">
              <li className="terms__decimal-item">
                O Pacote de Anúncios (“Pacote”) contratado pelo Cliente é composto pelos seguintes
                tipos de anúncios:
                <Accordion title="Plano básico" content={PLANO_BASICO} />
                <Accordion title="Plano essencial" content={PLANO_ESSENCIAL} />
                <Accordion title="Plano premium" content={PLANO_PREMIUM} />
              </li>
              <li className="terms__decimal-item">
                O anúncio poderá conter até 09 (nove) fotos do veículo e permanecerá publicado pelo
                período correspondente ao plano escolhido.
              </li>
            </ol>
          </li>
          <li className="terms__decimal-item">
            <strong>Valor do Pacote</strong>
            <ol className="terms__decimal-list">
              <li className="terms__decimal-item">
                O valor do Pacote será informado pelo ICARROS e pago pelo Cliente no ato da
                contratação. O pagamento poderá ser realizado das seguintes formas:
                <ol className="terms__decimal-list">
                  <li className="terms__decimal-item">
                    Para as contratações via dispositivos móveis (aplicativo iCarros e site por
                    internet móvel): exclusivamente por meio de cartão de crédito, ou
                  </li>
                  <li className="terms__decimal-item">
                    Para as contratações via site realizadas por computador: por meio de cartão de
                    crédito ou boleto emitido pelo ICARROS e apresentado ao Cliente para pagamento
                    imediato, no momento do cadastro do Anúncio.
                  </li>
                </ol>
              </li>
              <li className="terms__decimal-item">
                O pagamento deverá ser realizado no momento do cadastro do Anúncio sendo que a sua
                divulgação está condicionada a essa confirmação. Em caso de vencimento do boleto, o
                Cliente poderá gerar uma nova via acessando a área logada do site.
              </li>
            </ol>
          </li>
          <li className="terms__decimal-item">
            <strong>Condições para utilização do Pacote</strong>
            <ol className="terms__decimal-list">
              <li className="terms__decimal-item">
                O Cliente é integralmente responsável pelas informações veiculadas nos anúncios.
                Informações falsas ou de propriedade de terceiros poderão acarretar o cancelamento
                do anúncio, sem reembolso.
              </li>
              <li className="terms__decimal-item">
                O ICARROS poderá compartilhar e publicar o anúncio do Cliente, e todos os dados
                relacionados, em outros sítios de anúncios de veículos e plataformas digitais com os
                quais mantenha parceria.
              </li>
              <li className="terms__decimal-item">
                O ICARROS não se responsabiliza pelas negociações havidas pelo Cliente com o
                destinatário final (usuários finais do site).
              </li>
              <li className="terms__decimal-item">
                O ICARROS não garante a concretização das vendas dos veículos anunciados.
              </li>
              <li className="terms__decimal-item">
                O ICARROS poderá entrar em contato com o Cliente, utilizando as informações de
                cadastro, 1 além de enviar informações sobre segurança, utilização e alterações do
                produto ou serviço contratado, além de informações sobre novos produtos e serviços
                do ICARROS, ou das empresas Itaú Unibanco. O contato também poderá ser efetuado via
                e-mail, mensagem de texto (SMS), via aplicativo de celular (push) ou via telefone.
                Caso o Cliente não queira receber notificações referentes a novos produtos e
                serviços ele poderá solicitar, diretamente ao ICARROS, a interrupção do envio de
                informações dessa natureza. Para os casos de notificações enviadas via aplicativo de
                celular, o Cliente poderá desabilitar o recebimento nas configurações do sistema
                operacional do respectivo aparelho. Se o ICARROS tiver uma informação muito
                importante para lhe passar, a mensagem será enviada mesmo com a permissão
                desabilitada.
                <ol className="terms__decimal-list">
                  <li className="terms__decimal-item">
                    O ICARROS e as demais empresas do Conglomerado Itaú Unibanco tratam os dados
                    pessoais de pessoas físicas (como clientes, representantes e sócios/acionistas
                    de clientes pessoa jurídica) para diversas finalidades relacionadas ao
                    desempenho de suas atividades (como, por exemplo, (i) oferta, divulgação,
                    prestação de serviços e fornecimento de produtos; (ii) avaliação dos produtos e
                    serviços mais adequados ao seu perfil; (iii) atividades financeiras, de crédito,
                    de investimento e cobrança; (iv) cumprimento de obrigações legais, regulatórias
                    e requisições de autoridades administrativas e judiciais; (v) para exercício
                    regular de direitos e fins de processos administrativos e judiciais; (vi)
                    análise, gerenciamento e tratamento de potenciais riscos, incluindo os de
                    crédito, fraude e segurança; (vii) verificação da sua identidade e dados
                    pessoais, inclusive dados biométricos, para fins de autenticação, segurança e/ou
                    prevenção à fraude em sistemas eletrônicos próprios ou de terceiros; (viii)
                    avaliação, manutenção e aprimoramento dos nossos serviços; (xi) hipóteses de
                    legítimo interesse, como desenvolvimento e ofertas de produtos e serviços).
                  </li>
                  <li className="terms__decimal-item">
                    Os seus dados poderão ser compartilhados para as finalidades previstas neste
                    documento e na nossa Política de Privacidade, como, por exemplo, entre as
                    empresas do Conglomerado Itaú, com prestadores de serviços e fornecedores
                    localizados no Brasil ou no exterior, órgãos reguladores e entidades públicas,
                    inclusive administrativas e judiciais e, ainda, com parceiros estratégicos para
                    possibilitar a oferta de produtos e serviços. Apenas compartilharemos dados na
                    medida necessária, com segurança e de acordo com a legislação aplicável.
                  </li>
                  <li className="terms__decimal-item">
                    Para maiores informações sobre os dados coletados, as finalidades de tratamento,
                    compartilhamento de dados e sobre os seus direitos (como de correção, acesso aos
                    dados e informações sobre o tratamento, eliminação, bloqueio, exclusão, oposição
                    e portabilidade de dados pessoais), acesse a nossa Política de Privacidade em
                    nossos sites e aplicativos.
                  </li>
                </ol>
              </li>
              <li className="terms__decimal-item">
                Ao aderir a este Termo, o Cliente expressamente aceita e concorda com a coleta, uso
                e compartilhamento de seus dados cadastrais e informações descritas nos Termos de
                Uso do site do ICARROS e na Política de Privacidade do ICARROS e das empresas do
                Conglomerado Itaú Unibanco. O Cliente deve ler atentamente os Termos de Uso do site
                e a Política de Privacidade antes de contratar produtos e serviços ou utilizar os
                Sites e Aplicativos do ICARROS.
              </li>
              <li className="terms__decimal-item">
                Este Termo será válido pelo mesmo período do Pacote contratado, sendo prerrogativa o
                cancelamento por parte do Cliente a qualquer momento, sem ser devido, após a
                veiculação do anúncio, nenhum tipo de reembolso ou abatimento do valor pago.
              </li>
              <li className="terms__decimal-item">
                O ICARROS poderá, a qualquer tempo e sem aviso prévio, alterar as características,
                rotinas e soluções das áreas, páginas e programas destinados ao controle e exibição
                dos anúncios contratados, bem como suspender, limitar o acesso ao site, desativar o
                anúncio para validação dos dados inseridos no site e/ou solicitar documentação do
                veículo e do anunciante para liberação do anúncio.
                <ol className="terms__decimal-list">
                  <li className="terms__decimal-item">
                    Caso necessário, o ICARROS poderá solicitar ao anunciante particular a
                    apresentação da documentação abaixo a fim de validar as informações do anúncio a
                    ser publicado:
                    <ol className="terms__roman-list">
                      <li className="terms__roman-item">
                        Anúncio de carro usado/seminovo:
                        <ol className="terms__alphabetical-list">
                          <li className="terms__alphabetical-item">
                            cópia do documento de identificação do proprietário do veículo e
                            anunciante
                          </li>
                          <li className="terms__alphabetical-item">
                            cópia do documento do veículo (CRLV)
                          </li>
                        </ol>
                      </li>

                      <li className="terms__roman-item">
                        Anúncio de carro 0KM:
                        <ol className="terms__alphabetical-list">
                          <li className="terms__alphabetical-item">
                            cópia do documento de identificação do proprietário do veículo e
                            anunciante
                          </li>
                          <li className="terms__alphabetical-item">
                            cópia da nota fiscal de compra do veículo, na ausência do CRLV
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li className="terms__decimal-item">
                O Cliente declara que o anúncio ora contratado não tem relação com eventual
                atividade empresarial e não visa desenvolver ou fomentar atividade econômica
                organizada para a produção ou circulação de bens ou de serviços.
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </div>
  );
}
